<template lang="pug">
  .lei-popover-box
    slot(v-if="!isHoverTrigger")
    el-popover(
      v-if="textLess"
      :popper-class="rootClass",
      :placement="truePosition",
      :trigger="this.trigger",
      @hide="hide",
      :width="width",
      :open-delay="350",
      :disabled="disable")

      slot(slot="reference" v-if="isHoverTrigger")

      font-awesome-icon.lei-popover-icon(
        slot="reference"
        icon="info-circle"
        @click.stop=""
        v-else)

      .popover-content(@touchstart.stop="")
        slot(name="content")
          .text-wrap
            p.less(v-html="textLess")
            template(v-if="showMore")
              .more.options(v-if="Array.isArray(text.full)")
                .option(v-for="title in text.full")
                  span.option-title {{title.title}}
                  span {{title.desc}}
              p.more(v-else) {{textMore}}
          .btn-wrapper(v-if="!hideBtn")
            .popover-btn(@click="toggleText") {{btnText}}
</template>
<script>
import { mapGetters, } from 'vuex'

export default {
  props: {
    text: {
      type: [ String, Object, Array, ],
      default: () => ({
        small: '',
        full: '',
      }),
    },
    rootClass: {
      type: String,
      default: 'lei-popover',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    width: {
      type: Number,
      default: 220,
    },
    trigger: {
      type: String,
      default: 'click',
      validate: (value) => {
        return [ 'click', 'hover', ].includes(value)
      },
    },
  },
  data () {
    return {
      showMore: false,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    textLess () {
      return typeof this.text === 'string' ? this.text : this.text.small
    },
    textMore () {
      return this.text.full
    },
    btnText () {
      return this.showMore ? 'Show less' : 'Show more'
    },
    hideBtn () {
      return typeof this.text === 'string' || this.text.full === ''
    },
    disable () {
      return !this.text || !this.text.small
    },
    truePosition () {
      return this.screenWidth > 450 ? this.placement : 'bottom'
    },
    isHoverTrigger () {
      return this.trigger === 'hover'
    },

    ...mapGetters([ 'screenWidth', ]),
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  methods: {
    toggleText () {
      this.showMore = !this.showMore
    },
    hide () {
      this.showMore = false
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  ::-webkit-scrollbar
    width 4px
  ::-webkit-scrollbar-thumb
    background $default-color-bold-1
  ::-webkit-scrollbar-thumb:hover
    background $black-color

  .lei-popover-box
    display flex
    align-items center

  .lei-popover
    .popover-content
      font-size 95%

      .btn-wrapper
        display flex
        justify-content flex-end
        margin-top 10px
        font-weight 600

        .popover-btn
          color $default-color
          text-decoration underline

          &:hover
            cursor pointer
            color $primary-color

      .more
        border-top 1px solid $default-color-light-1
        padding-top 1em
        margin-top 1em

      .options
        max-height 300px
        overflow hidden
        overflow-y auto

      .option
        margin-bottom 4px
        .option-title
          font-weight bold

    .text-wrap
      word-break normal
      text-align left

  .lei-popover-icon
    font-size 24px
    padding 0 5px
    width 1em
    box-sizing border-box !important
    color $cyprus-color
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiPopover.vue